import React from "react";

export default function NoMatchPage() {
  return (
    <div className="container">
      <h4>Page not found</h4>
    </div>
  );
}
